<template>
  <div class="nx-signing-modal-method-p12">
    <h4>{{ $t('PrepareP12') }}</h4>

    <h5 class="mt-4">
     {{ $t('AskCertificate') }}
    </h5>

    <p class="mt-4">
      <b-spinner />
    </p>
  </div>
</template>

<script>
import SignClient from '@/api/sign-client.api';
import { SignApi } from "@/api";

export default {
  props: {
    value: {}
  },
  async created() {
    try {
      const signClient = new SignClient();
      await signClient.init();
      let pdfsDigests = this.value.digests;
      let signatures = [];

      if (pdfsDigests && pdfsDigests.length > 0) {
        const data = await signClient.p12SignPdfBatch(pdfsDigests);
        const pdfsSignatures = data.data;
        var cert = data.cert;
        var pdfsSignaturesMapped =  pdfsSignatures.map((x) => ({
          cert : cert,
          fileID : -1,
          signature: x.signature,
          digest: x.digest
        }));

        signatures.push(...pdfsSignaturesMapped)
      }
      console.log(signatures);
      this.$emit('input', {
        ...this.value,
        signatures: signatures
      });
      this.$emit('next');
    } catch (ex) {
      if (ex.response) {
        this.$emit('input', ex.response.data.error);
      } else if (ex.message) {
        this.$emit('input', ex.message);
      }
      this.$emit('fail');
      throw ex;
    }
  },
  i18n: {
    messages: {
      en: {
        PrepareP12: 'Please prepare your p12 certificate',
        AskCertificate: 'The client program is going to ask for your certificate'
      },
      zh_hk: {
        PrepareP12: '請準備好你的p12證書',
        AskCertificate: '客戶端程序將要求您提供證書'
      },
      zh_cn: {
        PrepareP12: '请准备好你的p12证书',
        AskCertificate: '客户端程序将要求您提供证书'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-method-p12 {
  text-align: center;
}
</style>
